import React, { useState, useEffect } from "react";
import { getAdmins, addAdmin, removeAdmin } from "../../firebase/firestoreService";

const OWNER_EMAIL = "patrickchimtedza@gmail.com";

export default function AdminsSection() {
  const [admins,  setAdmins]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [email,   setEmail]   = useState("");
  const [error,   setError]   = useState("");
  const [saving,  setSaving]  = useState(false);

  const load = async () => {
    setLoading(true);
    const data = await getAdmins();
    setAdmins(data);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleAdd = async () => {
    const trimmed = email.trim().toLowerCase();
    if (!trimmed) { setError("Enter an email address."); return; }
    if (trimmed === OWNER_EMAIL) { setError("Owner is always an admin."); return; }
    if (admins.some((a) => a.email === trimmed)) { setError("Already an admin."); return; }
    setSaving(true);
    setError("");
    await addAdmin(trimmed);
    setEmail("");
    await load();
    setSaving(false);
  };

  const handleRemove = async (id) => {
    await removeAdmin(id);
    await load();
  };

  return (
    <div>
      <div className="dash-main__header">
        <h2 className="dash-main__title">Admins</h2>
      </div>

      <div className="admins__card">
        <p style={{ fontSize: 12, color: "#aaa", marginBottom: 20, lineHeight: 1.6 }}>
          These users can access the admin dashboard. The owner account is always an admin.
        </p>

        <div className="admins__row admins__row--owner">
          <span className="admins__email">{OWNER_EMAIL}</span>
          <span className="admins__badge">Owner</span>
        </div>

        {loading ? (
          <p style={{ fontSize: 13, color: "#aaa" }}>Loading…</p>
        ) : (
          admins.map((a) => (
            <div key={a.id} className="admins__row">
              <span className="admins__email">{a.email}</span>
              <button className="btn-danger" onClick={() => handleRemove(a.id)}>Remove</button>
            </div>
          ))
        )}

        <div className="admins__add-row">
          <input
            className="form-input"
            placeholder="Email address"
            value={email}
            onChange={(e) => { setEmail(e.target.value); setError(""); }}
            onKeyDown={(e) => e.key === "Enter" && handleAdd()}
          />
          <button className="btn-primary" onClick={handleAdd} disabled={saving}>
            {saving ? "Adding…" : "Add Admin"}
          </button>
        </div>
        {error && <p style={{ fontSize: 12, color: "#c0392b", marginTop: 8 }}>{error}</p>}
      </div>
    </div>
  );
}
